import { merge } from 'ramda'
import {
  QUESTION_REQUEST,
  QUESTION_RECEIVE,
  ONBOARDING_REQUEST_FAIL,
  ONBOARDING_REQUEST_SUCCESS,
} from './actions'

const initialState = {
  error: null,
  lastAnswerSubmited: false,
  loading: false,
}

export default function onboardingReducer (state = initialState, action) {
  switch (action.type) {
    case QUESTION_REQUEST: {
      return merge(state, { loading: true, question: {} })
    }

    case QUESTION_RECEIVE: {
      return merge(state, { loading: false, question: action.payload })
    }

    case ONBOARDING_REQUEST_FAIL: {
      return merge(state, {
        error: action.payload,
        loading: false,
        question: {},
      })
    }

    case ONBOARDING_REQUEST_SUCCESS: {
      return merge(state, {
        error: false,
        lastAnswerSubmited: action.payload.lastAnswer,
        loading: false,
      })
    }

    default: {
      return state
    }
  }
}
